export class Subtotal {
    subscriptionAmount = 0; // before discount
    subscriptionTotal = 0; // after discount
    singleAmount = 0; // before discount
    singleTotal = 0; // after discount
    subscriptionDiscount = 0;
    singleDiscount = 0;
    tax = 0;
    taxRate?: number; 
    messages: string[] = [];
    quantity?: number;
}
